export function normalizeFreeTicketRequirements(minFreeTickets, minGoldenTickets) {
  const minFree = Math.max(0, parseInt(minFreeTickets, 10) || 0);
  const minGolden = Math.max(0, parseInt(minGoldenTickets, 10) || 0);
  const valid = minFree > 0 || minGolden > 0;
  return {
    minFreeTickets: minFree,
    minGoldenTickets: minGolden,
    minTotalStake: minFree + minGolden,
    valid,
  };
}

export function formatTicketPeriodDays(days) {
  const d = Math.max(1, parseInt(days, 10) || 1);
  if (d === 1) return 'day';
  return `${d} days`;
}

export function formatGrantRate(tickets, periodDays) {
  const qty = Math.max(0, parseInt(tickets, 10) || 0);
  if (qty <= 0) return '—';
  return `+${qty} / ${formatTicketPeriodDays(periodDays)}`;
}
